var _defs, _line, _line2, _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNewcontactIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 19.32 13.87",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-10,.cls-2,.cls-3,.cls-9{fill:none;}.cls-2{clip-rule:evenodd;}.cls-10,.cls-3,.cls-9{stroke:#1d3152;}.cls-10,.cls-3{stroke-linecap:round;}.cls-3{stroke-linejoin:round;stroke-width:0.9px;}.cls-4{clip-path:url(#clip-path);}.cls-5{clip-path:url(#clip-path-2);}.cls-6{isolation:isolate;}.cls-7{clip-path:url(#clip-path-3);}.cls-8{clip-path:url(#clip-path-4);}.cls-10,.cls-9{stroke-miterlimit:10;}.cls-9{stroke-width:2px;}.cls-11{clip-path:url(#clip-path-6);}.cls-12{clip-path:url(#clip-path-7);}.cls-13{clip-path:url(#clip-path-8);}.cls-14{clip-path:url(#clip-path-9);}.cls-15{clip-path:url(#clip-path-10);}.cls-16{clip-path:url(#clip-path-11);}.cls-17{clip-path:url(#clip-path-12);}.cls-18{clip-path:url(#clip-path-13);}.cls-19{clip-path:url(#clip-path-14);}.cls-20{clip-path:url(#clip-path-15);}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 7.58,
    cy: 4.3,
    r: 3.83
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 0.2,
    y: 0.48,
    width: 14,
    height: 14
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: -7.21,
    y: -10.27,
    width: 29,
    height: 29
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-4"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 2.79,
    y: -0.27,
    width: 9,
    height: 9
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-6"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M50.37-213.32a1.72,1.72,0,0,0,1.25-.51,1.72,1.72,0,0,0,.51-1.25,1.66,1.66,0,0,0-.51-1.23,1.72,1.72,0,0,0-1.25-.51,1.66,1.66,0,0,0-1.23.51,1.66,1.66,0,0,0-.51,1.23,1.75,1.75,0,0,0,.5,1.25A1.7,1.7,0,0,0,50.37-213.32Zm-4.91,0a1.72,1.72,0,0,0,1.25-.51,1.72,1.72,0,0,0,.51-1.25,1.66,1.66,0,0,0-.51-1.23,1.72,1.72,0,0,0-1.25-.51,1.68,1.68,0,0,0-1.23.51,1.66,1.66,0,0,0-.51,1.23,1.75,1.75,0,0,0,.5,1.25A1.7,1.7,0,0,0,45.46-213.32Zm-4.91,0a1.72,1.72,0,0,0,1.25-.51,1.72,1.72,0,0,0,.51-1.25,1.66,1.66,0,0,0-.51-1.23,1.72,1.72,0,0,0-1.25-.51,1.68,1.68,0,0,0-1.23.51,1.66,1.66,0,0,0-.51,1.23,1.75,1.75,0,0,0,.5,1.25A1.7,1.7,0,0,0,40.55-213.32Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-7"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M-15.81-305.12A7.12,7.12,0,0,0-26.2-306a7.32,7.32,0,0,0-.55,9.54,6.58,6.58,0,0,0,3.4,2.26,6.9,6.9,0,0,0,4.05-.08,8.8,8.8,0,0,0,3.5-2.33v.47c0,2.29,0,4.59,0,6.88a.49.49,0,0,1-.4.56,16.73,16.73,0,0,1-5.72,1.13,13.31,13.31,0,0,1-13-11,13.19,13.19,0,0,1,9.82-15.22A14.18,14.18,0,0,1-16-313a.42.42,0,0,1,.23.28c0,2.5,0,5,0,7.61"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-8"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M60.6-319.08h.61c2.5,0,5,.1,7.5-.1,5.68-.46,10.41-2.75,13.59-7.68a16.77,16.77,0,0,0,2-6,15.59,15.59,0,0,1,1.27,1.77,10,10,0,0,1-1,11.79c-.36.43-.36.43,0,.82l2,1.85A1.4,1.4,0,0,1,86.9-315a1.38,1.38,0,0,1-1.35.89c-4.72,0-9.46.1-14.18-.05a14.77,14.77,0,0,1-10.43-4.51c-.1-.1-.18-.21-.34-.39"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-9"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M80.47-338.17a12.58,12.58,0,0,0-6.13-5.61A17.21,17.21,0,0,0,63.78-345a14.38,14.38,0,0,0-8.33,4.4,10,10,0,0,0-2.12,11,10.22,10.22,0,0,0,1.87,3c-.71.8-1.36,1.57-2.06,2.3a1.54,1.54,0,0,0-.5,1.76,1.44,1.44,0,0,0,1.55.9c4.23,0,8.47,0,12.71,0a20.58,20.58,0,0,0,2.83-.18,15.06,15.06,0,0,0,8.86-4.35,10.22,10.22,0,0,0,1.88-11.95M69-329.53H60.13A1.53,1.53,0,0,1,58.49-331a1.53,1.53,0,0,1,1.6-1.52H69A1.48,1.48,0,0,1,70.62-331a1.48,1.48,0,0,1-1.6,1.5m4.6-4a1.38,1.38,0,0,1-.45.08H60a1.5,1.5,0,0,1-1.44-1.29,1.52,1.52,0,0,1,.9-1.6,2.24,2.24,0,0,1,.73-.12h13a1.51,1.51,0,0,1,1.48,1.24,1.51,1.51,0,0,1-1,1.69"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-10"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M-4-288.3h-6.52v-25.2H-4v9.68H5.45v-9.7h.44c1.9,0,3.8,0,5.7,0,.36,0,.45.11.45.45q0,12.18,0,24.37c0,.12,0,.25,0,.4H5.47v-10.35H-4Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-11"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M41.27-288.29h-3c-1.19,0-2.38,0-3.57,0a.5.5,0,0,1-.59-.41c-.39-1.21-.82-2.4-1.22-3.61-.09-.25-.19-.37-.49-.37q-4.34,0-8.65,0c-.3,0-.4.1-.49.37-.42,1.25-.86,2.48-1.28,3.72-.06.2-.14.3-.37.3H15.13l-.2,0,1-2.55q4.23-11.1,8.44-22.19a.61.61,0,0,1,.69-.47c2.08,0,4.17,0,6.25,0a.51.51,0,0,1,.57.4q4.64,12.19,9.28,24.38c.05.14.09.28.15.46m-13.12-17.6h-.1c-1,2.72-1.91,5.45-2.87,8.2H31l-2.88-8.2"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-12"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "40.73 -307.94 40.73 -313.49 58 -313.49 58 -307.95 52.65 -307.95 52.65 -288.32 46.1 -288.32 46.1 -307.94 40.73 -307.94"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-13"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M39.38-333.31a6.08,6.08,0,0,1,3.29,2.65A7.07,7.07,0,0,1,37.86-320a21.35,21.35,0,0,1-3.09.26c-1.86,0-3.72,0-5.58,0h-.48v-25.2l.23,0c2.08.05,4.17,0,6.24.17a6.79,6.79,0,0,1,5.69,9.41,6.53,6.53,0,0,1-.64,1.08C40-334,39.69-333.68,39.38-333.31Zm-6.87,2.37v7.57l.35,0c1.1,0,2.21,0,3.31-.07a4.29,4.29,0,0,0,1.11-.22,3.53,3.53,0,0,0,2.62-3.64,3.6,3.6,0,0,0-2.81-3.39A19.37,19.37,0,0,0,32.51-330.94Zm0-3.19a8.68,8.68,0,0,0,3.42-.39A2.76,2.76,0,0,0,37.46-336a4.85,4.85,0,0,0,.16-3.08,2.75,2.75,0,0,0-1.08-1.6c-1.23-.88-2.63-.77-4-.73Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-14"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M22.64-344.95v.46c0,5.24,0,10.49,0,15.73a8.85,8.85,0,0,1-4.93,8.43A9.34,9.34,0,0,1,4.27-326a9.75,9.75,0,0,1-.31-2.4c0-5.37,0-10.74,0-16.11,0-.12,0-.24,0-.4H7.75v.55c0,5,0,10,0,15a11.91,11.91,0,0,0,.37,2.85,4.72,4.72,0,0,0,4.14,3.65A5.33,5.33,0,0,0,17.73-325a5.73,5.73,0,0,0,1-2.94,18.43,18.43,0,0,0,.1-2v-15Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-15"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "-10.12 -344.96 -6.34 -344.96 -6.34 -323.35 1.05 -323.35 1.05 -319.78 -10.12 -319.78 -10.12 -344.96"
  })))), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 13.41,
    y1: 6.55,
    x2: 18.65,
    y2: 6.55
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 16.03,
    y1: 3.94,
    x2: 16.03,
    y2: 9.16
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-4"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-5"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-6"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-7"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-8"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-9",
    cx: 7.58,
    cy: 4.3,
    r: 3.83
  }))))))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    className: "cls-5"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M1.56,13.17A4,4,0,0,1,5.72,9.34H9.45a4,4,0,0,1,4.16,3.83"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewcontactIcon);
export default __webpack_public_path__ + "static/media/newcontact-icon.d81644cde9d3b589b87ec1615c43c0e3.svg";
export { ForwardRef as ReactComponent };